<template>
  <div class="page-container">
    <div class="query-title">发运明细表</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel('发运明细表')" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            :span-method="mergeRowMethod"
            @filter-change="filterChangeEvt"
          >
            <template #wantCode="{ row }">
              <span class="blue" @click="showWantGoodsApply(row.id)">{{ row.wantCode }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { getShippingDetailReport,apiExportExcelShippingInfoDatas } from '@/api/applyForGoods/index'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/shipmentDtlInfoForms'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { getToken } from '@/utils/auth'
export default {
  mixins: [tableMixins],
  data() {
    return {
      pageSearch,
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    showWantGoodsApply(id){
      const isSearchPage = '1'
      this.$router.push({
        path: '/wly/to-goods/data-searching/delivery-search-detail',
        query: {
          id,
          isSearchPage: isSearchPage
        }
      })
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await getShippingDetailReport(params)
        if (Rows.length === 0 && (Total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = [
        'customerCode',
        'customerName',
        'saleCenterTextView',
        'brandBqTextView',
        'archiveTime',
        'createdDated',
        'handleNode',
        'productDesc',
        'isShunt',
        'quotasYear',
        'planTypeTextView',
        'wantQuantity',
        'receiveAddress',
        'shipStatusTextView'
      ]
      const cellValue = row[column.property]
      if (column.property === 'wantCode') {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      } else if (fields.includes(column.property)) {
        let nextRow = visibleData[_rowIndex + 1]
        const prevRow = visibleData[_rowIndex - 1]
        if (prevRow && prevRow['wantCode'] === row['wantCode']) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow['wantCode'] === row['wantCode']) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return {
              rowspan: countRowspan,
              colspan: 1
            }
          }
        }

        // let countRowspan = 1

        // while (nextRow && nextRow[column.property] === cellValue && row['wantCode'] === nextRow['wantCode']) {
        //   nextRow = visibleData[++countRowspan + _rowIndex]
        // }
        // if (countRowspan > 1) {
        //   return { rowspan: countRowspan, colspan: 1 }
        // }
      }
      // if (cellValue && fields.includes(column.property)) {
      //   const prevRow = visibleData[_rowIndex - 1]
      //   let nextRow = visibleData[_rowIndex + 1]

      //   // if (prevRow && prevRow[column.property] === cellValue) {
      //   //   return { rowspan: 0, colspan: 0 }
      //   // } else {
      //   //   let countRowspan = 1
      //   //   while (nextRow && nextRow[column.property] === cellValue && row['wantCode'] === ) {
      //   //     nextRow = visibleData[++countRowspan + _rowIndex]
      //   //   }
      //   //   if (countRowspan > 1) {
      //   //     return { rowspan: countRowspan, colspan: 1 }
      //   //   }
      //   // }
      // }
    },
    // 导出全部 导出本页
    // 后端导出 下载
    async exportExcel(fileName) {
       // alert(type)
      const params = {
        templateCode:'shipmentInfoDetail',
        ...this.allConditions
      }

      const res = await apiExportExcelShippingInfoDatas(params)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      // link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style scoped>
.blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/report-forms-manage/shipmentInformationDetailForms.vue